"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _wtlContext = require("../context/wtl-context");

var _googleSearchConsolePlugin = require("../plugins/google-search-console-plugin");

var getPathName = function getPathName() {
  if (typeof window !== 'undefined') {
    return window.location.pathname;
  }

  return '';
};

var Metadata =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Metadata, _React$Component);

  function Metadata() {
    (0, _classCallCheck2["default"])(this, Metadata);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Metadata).apply(this, arguments));
  }

  (0, _createClass2["default"])(Metadata, [{
    key: "render",
    value: function render() {
      var config = this.context.config;
      return _react["default"].createElement(_reactHelmet.Helmet, {
        defaultTitle: config.DEFAULT_TITLE,
        titleTemplate: "%s - ".concat(config.DEFAULT_TITLE)
      }, _react["default"].createElement("meta", {
        name: "docsearch:version",
        content: "2.0"
      }), _react["default"].createElement("html", {
        lang: config.DEFAULT_LOCALE
      }), _react["default"].createElement("meta", {
        "http-equiv": "content-language",
        content: config.DEFAULT_LOCALE
      }), _react["default"].createElement("link", {
        rel: "canonical",
        href: "".concat(config.SITE_URL).concat(getPathName())
      }), _react["default"].createElement("link", {
        rel: "shortcut icon",
        href: config.FAV_ICON
      }), _react["default"].createElement("meta", {
        name: "description",
        content: config.SEO_DESCRIPTION
      }), _react["default"].createElement("meta", {
        name: "keywords",
        content: config.SEO_KEYWORDS.join(', ')
      }), _react["default"].createElement("meta", {
        property: "og:url",
        content: config.SITE_URL
      }), _react["default"].createElement("meta", {
        property: "og:type",
        content: "website"
      }), _react["default"].createElement("meta", {
        property: "og:locale",
        content: config.DEFAULT_LOCALE
      }), _react["default"].createElement("meta", {
        property: "og:site_name",
        content: config.DEFAULT_TITLE
      }), _react["default"].createElement("meta", {
        property: "og:image",
        content: config.SEO_LOGO
      }), _react["default"].createElement("meta", {
        property: "og:image:width",
        content: "512"
      }), _react["default"].createElement("meta", {
        property: "og:image:height",
        content: "512"
      }), _react["default"].createElement("meta", {
        name: "twitter:card",
        content: "summary"
      }), _react["default"].createElement("meta", {
        name: "twitter:site",
        content: config.TWITTER_URL
      }));
    }
  }]);
  return Metadata;
}(_react["default"].Component);

exports.Metadata = Metadata;
Metadata.contextType = _wtlContext.WtlContext;